/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Statistics_Interview_Date_ColumnInputs */

const en_admin_statistics_interview_date_column = /** @type {(inputs: Admin_Statistics_Interview_Date_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview date`)
};

const de_admin_statistics_interview_date_column = /** @type {(inputs: Admin_Statistics_Interview_Date_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesprächstermin`)
};

/**
* | output |
* | --- |
* | "Interview date" |
*
* @param {Admin_Statistics_Interview_Date_ColumnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_interview_date_column = /** @type {((inputs?: Admin_Statistics_Interview_Date_ColumnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_Interview_Date_ColumnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_interview_date_column(inputs)
	return en_admin_statistics_interview_date_column(inputs)
});